var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('flowy-drag-handle',{staticClass:"grab"},[_c('b-card',{staticClass:"custom-accordion shadow-none mb-1"},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.title)+" ")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }